import { addFrameToFocusPresentation } from "@/lib/presentation-mode";
import { useFramesStore } from "@/stores/frames-store";

export function focusConversationFrameLayout(targetFrameId: string) {
  const target = useFramesStore.getState().framesById[targetFrameId];
  if (target?.frameType !== "conversation") return;

  addFrameToFocusPresentation(targetFrameId);
}
